import { motion } from "framer-motion";
import Separator from "../components/Separator.tsx";

interface InputErrorProps {
	error?: string;
	className?: string;
}

function InputError({
	error,
	className = "error-input-text",
}: InputErrorProps) {
	if (!error) return null;
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
		>
			<div className={className} style={{ color: "red", fontSize: "0.8rem" }}>
				{error}
			</div>
		</motion.div>
	);
}

export default InputError;
